import React, { memo } from "react";
import { Group, Text, Select, ActionIcon } from "@mantine/core";
import Icon from "../Components/Icon";

export const EpPagination = memo(
  ({
    onPrev,
    onNext,
    onPageSizeChange,
    pageNum = 1,
    pageSize = 10,
    isLastPage = false,
  }: {
    onNext?: Function;
    onPrev?: Function;
    onPageSizeChange?: Function;
    pageNum?: number;
    pageSize?: number;
    isLastPage?: boolean;
  }) => {
    return (
      <Group>
        <Group>
          <Text>items per page:</Text>
          <Select
            data={["10", "25", "50", "100"]}
            value={pageSize + ""}
            onChange={(v) => {
              if (v) {
                if (onPageSizeChange && parseInt(v) !== pageSize) {
                  onPageSizeChange(parseInt(v));
                }
              }
            }}
            sx={{ width: 80 }}
          ></Select>
        </Group>
        <Group>
          <Text>
            {pageNum * pageSize - pageSize} - {pageNum * pageSize}
          </Text>
        </Group>
        <Group>
          <ActionIcon
            disabled={pageNum === 1}
            style={{ transform: "rotateY(0deg)" }}
            onClick={() => {
              if (onPrev) {
                onPrev();
              }
            }}
          >
            <Icon name="icon-arrow-left-bold" size={15} />
          </ActionIcon>
          <ActionIcon
            disabled={isLastPage}
            style={{ transform: "rotateY(180deg)" }}
            onClick={() => {
              if (onNext) {
                onNext();
              }
            }}
          >
            <Icon name="icon-arrow-left-bold" size={15} />
          </ActionIcon>
        </Group>
      </Group>
    );
  }
);
export default EpPagination;
